import { toast } from "react-toastify";
import { URLRoutes } from "../../config";
import { KIOSK_CONFIG_URL } from "../../utilities/constants";
import { setLocalData } from "./localServiceSlice";
import i18n from "../../config/lang";
import { isEmptyValue } from "../../utilities";

const t = i18n.t;

export const startSetLocalData = () => {
    return async( dispatch ) => {
        try {
            const resp = await fetch(KIOSK_CONFIG_URL+'configLocal');
            const data = await resp.json();

            if(typeof OFFICE.data != 'undefined'){
                const { officeCode } = data;
                await location.replace(`${BASE_WEBSITE_URL}/${officeCode}`);
                return;
            }else if(isEmptyValue(OFFICE)){
                console.log("hola");

                await location.replace(BASE_WEBSITE_URL);
                return;
            }
            dispatch( setLocalData({ ...data }) );
        } catch (error) {
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            dispatch( setLocalData({}) );
            if(isEmptyValue(OFFICE)){
                console.log("hola");

                await location.replace(BASE_WEBSITE_URL);
                return;
            }
            return false;
        }
    }
}
